import {
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from "@/components/ui/tooltip";
import { formatUnitPrice } from "@/lib/utils";
import {
  formatPricingUnit,
  type CurrencyCode,
  type PricingUnit,
} from "@forgepoint/shared";

interface UnitPriceSublineProps {
  value: string;
  unit: PricingUnit;
  tooltip: string | null;
  currencyCode?: CurrencyCode;
  decimals?: number;
}

/** Muted "$X /unit" line under a quote line's unit price, with an explanatory tooltip. */
export function UnitPriceSubline({
  value,
  unit,
  tooltip,
  currencyCode,
  decimals,
}: UnitPriceSublineProps) {
  return (
    <TooltipProvider>
      <Tooltip>
        <TooltipTrigger asChild>
          <span className="text-[10px] sm:text-xs tabular-nums text-muted-foreground cursor-help">
            {formatUnitPrice(value, currencyCode, decimals)}
            <span className="ml-0.5">/{formatPricingUnit(unit)}</span>
          </span>
        </TooltipTrigger>
        <TooltipContent>
          <p>{tooltip}</p>
        </TooltipContent>
      </Tooltip>
    </TooltipProvider>
  );
}
